import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import clinicService from '../../../../../services/clinic.service';
import {
    SKIP_FIELDS,
    getServiceEntries,
    getServiceIconClass,
    getServiceIconTone,
    getServiceLabel,
} from './clinicServicesUtils';
function ClinicServicesForm({ clinicSettings, updateSettings, onCancel }) {
    const { register, handleSubmit } = useForm({
        defaultValues: clinicSettings,
    });
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (data) => {
        setIsLoading(true);
        const payload = {};

        for (const key in data) {
            if (key === 'clinicId' || key === 'id') {
                payload[key] = data[key];
                continue;
            }
            if (SKIP_FIELDS.includes(key)) continue;
            payload[key] = Boolean(data[key]);
        }

        clinicService
            .updateSettings(clinicSettings.clinicId, payload)
            .then((res) => {
                toast.success('Clinic services updated', { position: toast.POSITION.BOTTOM_RIGHT });
                updateSettings(res.data);
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Error updating settings', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const serviceGroups = getServiceEntries(clinicSettings);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {serviceGroups.map((group, index) => (
                <div key={group.title}>
                    <div className={`clinic-services-section-title${index === 0 ? ' clinic-services-section-title--first' : ''}`}>
                        {group.title}
                    </div>
                    {group.items.map((item) => (
                        <div key={item.key} className="clinic-services-row">
                            <span className="clinic-services-row__label">
                                <span className={`clinic-services-row__icon clinic-services-row__icon--${getServiceIconTone(item.key)}`}>
                                    <i className={`bi ${getServiceIconClass(item.key)}`}></i>
                                </span>
                                {getServiceLabel(item.key)}
                            </span>
                            <div className="form-check form-switch mb-0">
                                <input type="checkbox" className="form-check-input" id={`service-${item.key}`} disabled={isLoading} {...register(item.key)} />
                            </div>
                        </div>
                    ))}
                </div>
            ))}

            <div className="clinic-services-form-actions">
                {onCancel && (
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onCancel} disabled={isLoading}>
                        Cancel
                    </button>
                )}
                <button type="submit" className="btn btn-success btn-sm" disabled={isLoading}>
                    {isLoading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                            Saving…
                        </>
                    ) : (
                        <>
                            <i className="bi bi-floppy me-1"></i>
                            Save Changes
                        </>
                    )}
                </button>
            </div>
        </form>
    );
}

export default ClinicServicesForm;
